import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { api, apiErr } from "../api";
import { PanelPage, Header, FullLoader, BrandLogo } from "../ui";
import ClinicalSlide from "../components/ClinicalSlide";
import { SPEC } from "../fields";

export default function CaseView() {
  const { id } = useParams();
  const nav = useNavigate();
  const [c, setC] = useState(null);
  useEffect(() => {
    api.get(`/cases/${id}`).then((r) => setC(r.data)).catch((e) => { toast.error(apiErr(e)); nav("/dashboard?tab=casos"); });
  }, [id, nav]);

  return (
    <PanelPage>
      <Header />
      <div className="pn-visor">
        {!c ? <FullLoader text="Cargando caso…" /> : (
          <main className="max-w-6xl mx-auto px-4 sm:px-8 py-8">
            <Link to="/dashboard?tab=casos" className="inline-flex items-center gap-1.5 text-sm text-white/60 hover:text-white mb-5 pn-noprint"><ArrowLeft size={15} /> Casos clínicos</Link>
            <ClinicalSlide heading={`Caso ${c.patient_name} · Fecha ${c.fecha || "—"} · Consulta: ${c.consulta || "—"}`}
              title={c.title ? `Título: ${c.title}` : c.patient_name} cuadro={c.cuadro_clinico} labs={c.laboratorios}
              labMedia={c.lab_media} ekgMedia={c.ekg_media} ecoMedia={c.eco_media} ecoText={c.eco_text} diagnosis={c.diagnostico} dateLabel={c.fecha} labels={{ ...SPEC.visor, diagnosis: "Diagnóstico" }} />
            <div className="flex justify-center mt-10"><BrandLogo className="h-11" /></div>
          </main>
        )}
      </div>
    </PanelPage>
  );
}
